export enum BlockType {
    /**
	 * 비인가 액세스
	 */
	NOTAUTHROIZED_ACCESS,

	/**
	 * 비인가 설치
	 */
	NOTAUTHROIZED_INSTALL,

	/**
	 * 비인가 IP
	 */
	NOTAUTHROIZED_IP,

	/**
	 * 외부 열람
	 */
	EXTERNAL_ACCESS,
	
	/**
	 * 저장매체 분실: (장기간 미장착 저장매체)
	 */
	LOST_MEDIA,
	
	/**
	 * 내부 미설치 열람
	 */
	 INTERNAL_NOT_INSTALLED_ACCESS
}

export const BlockTypes = [
	{
	  value: BlockType[BlockType.NOTAUTHROIZED_ACCESS],
	  label: '비인가 엑세스',
	},
	{
	  value: BlockType[BlockType.NOTAUTHROIZED_INSTALL],
	  label: '비인가 설치',
	},
	{
	  value: BlockType[BlockType.NOTAUTHROIZED_IP],
	  label: '비인가 IP',
	},
	{
	  value: BlockType[BlockType.EXTERNAL_ACCESS],
	  label: '외부열람',
	},
	{
	  value: BlockType[BlockType.LOST_MEDIA],
	  label: '저장매체 분실',
	},
	{
	  value: BlockType[BlockType.INTERNAL_NOT_INSTALLED_ACCESS],
	  label: '내부 미설치 열람',
	}
  ];
  